import { useSimpleRegistrationContext } from "pages/SimpleRegistrationsPage";
import { maskName, maskBirthday, maskPhoneNumber } from "utils/maskString";
import { Box as MuiBox, Button as MuiButton, styled } from "@mui/material";
import { CustomerType } from "~/type/customer";

const Box = styled(MuiBox)`
  &.customers-container {
    margin-bottom: 3%;
    border: solid 1px #dee2ec;
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  &.customer-row {
    border-bottom: solid 1px #dee2ec;
    padding: 2%;
    font-size: 3vw;
    align-items: center;
    font-weight: bold;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    position: relative;
  }

  &.customer-row-landscape {
    height: 10vh;
    gap: 20px;
  }

  &.customer-row-portrait {
    height: 8vh;
    gap: 10px;
  }

  &.customer-row-last {
    border-bottom: none;
  }

  &.customer-name {
    width: 25%;
    min-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &.customer-gender {
    width: 80px;
    text-align: center;
  }

  &.customer-birthday {
    width: 20%;
    min-width: 135px;
    text-align: center;
  }

  &.customer-phone {
    width: 25%;
    min-width: 175px;
    text-align: center;
  }

  &.button-container {
    margin-left: auto;
    min-width: 100px;
  }
`;

const Button = styled(MuiButton)`
  &.register-button {
    width: 100%;
    padding: 2px 8px;
  }

  &.register-button-landscape {
    height: 7vh;
    font-size: 2vw;
  }

  &.register-button-portrait {
    height: 5vh;
    font-size: 3vw;
  }
`;

interface CustomersListProps {
  customers: CustomerType[];
  onClick: (customer: CustomerType) => void;
}

export const CustomersList = ({ customers, onClick }: CustomersListProps) => {
  const { isLandscape } = useSimpleRegistrationContext();

  const layoutMode = isLandscape ? "landscape" : "portrait";

  return (
    <Box className="customers-container">
      {customers.map((customer, i: number) => (
        <Box
          key={`customer-${i}`}
          className={`customer-row customer-row-${layoutMode} ${
            i === customers.length - 1 ? "customer-row-last" : ""
          }`}
        >
          <Box className="customer-name">{maskName(customer.name ?? "")}</Box>
          <Box className="customer-gender">
            {customer.sex === "female" ? "여" : "남"}
          </Box>
          <Box className="customer-birthday">
            {customer.birthday ? maskBirthday(customer.birthday) : ""}
          </Box>
          <Box className="customer-phone">
            {customer.phoneNumber ? maskPhoneNumber(customer.phoneNumber) : ""}
          </Box>
          <Box className="button-container">
            <Button
              variant="contained"
              className={`register-button register-button-${layoutMode}`}
              onClick={() => onClick(customer)}
            >
              접수
            </Button>
          </Box>
        </Box>
      ))}
    </Box>
  );
};
